/**
 * URL 관련 유틸리티
 *
 * ContentHeader, ShareDialog 등에서 공통으로 사용하는 URL 관련 함수들 통합.
 */

/** 공유 URL 생성 (room 파라미터만 유지) */
export const getShareUrl = (): string => {
  if (typeof window === 'undefined') return '';
  const u = new URL(window.location.href);
  const params = new URLSearchParams();
  if (u.searchParams.get('rname')) params.set('rname', u.searchParams.get('rname')!);
  if (u.searchParams.get('room')) params.set('room', u.searchParams.get('room')!);
  return `${u.protocol}//${u.host}${u.pathname}?${params.toString()}`;
};

/** 오브젝트를 쿼리스트링으로 직렬화 */
export const serialize = (obj: Record<string, unknown>): string =>
  Object.entries(obj)
    .filter(([, v]) => v !== undefined && v !== null)
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`)
    .join('&');

/** http:// URL을 https://로 변환 */
export const toHttps = (url: string): string =>
  url.replace(/^http:\/\//i, 'https://');

/** 전체화면 토글 */
export const toggleFullScreen = (): void => {
  if (!document.fullscreenElement) {
    document.documentElement.requestFullscreen?.();
  } else {
    document.exitFullscreen?.();
  }
};
